<template>
  <l-marker :lat-lng="latLng" :options="options" @click="markerClicked">
    <l-icon :icon-anchor="[20, 18]" :popup-anchor="[0, -20]">
      <StoreLocatorIcon :class="iconClasses" />
    </l-icon>

    <l-popup :options="popupOptions">
      <StoreLocatorStoreCard :position="position" :store="store" />
    </l-popup>
  </l-marker>
</template>

<script>
import StoreLocatorStoreCard from './StoreLocatorStoreCard.vue';
import StoreLocatorIcon from './StoreLocatorIcon.vue';

const ICON_BLOCK_SELECTOR = 'store-locator-icon';

export default {
  name: 'StoreLocatorMarker',
  components: { StoreLocatorIcon, StoreLocatorStoreCard },
  props: {
    position: {
      type: Object,
      default: null,
    },
    store: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isHighlighted: false,
    };
  },
  computed: {
    /**
     * @return {number[]}
     */
    latLng() {
      return [this.store.latitude, this.store.longitude];
    },
    /**
     * @return {Object}
     */
    options() {
      return { title: this.store.name };
    },
    /**
     * @return {string[]}
     */
    iconClasses() {
      const classes = [`${ICON_BLOCK_SELECTOR}--${this.store.type}`];

      if (this.isHighlighted) {
        classes.push(`${ICON_BLOCK_SELECTOR}--highlighted`);
      }

      return classes;
    },
    /**
     * @return {Object}
     */
    popupOptions() {
      return {
        minWidth: 300,
      };
    },
  },
  methods: {
    markerClicked() {
      this.isHighlighted = true;
      this.$emit('click');
    },
    popupClosed() {
      this.isHighlighted = false;
    },
  },
};
</script>
